import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
import LoginForm from '../views/LoginForm.vue'
import Main from '../components/Main.vue'
// import OAuthCallback from '../components/login/OAuthCallback.vue'
import { useUserProfileStore } from '../stores/userProfileStore'
import { useAppStore } from '../stores/appStore'
import { LoginRequired } from '../types/app/loginRequired'
import OAuthCallback from '../components/login/OAuthCallback.vue'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'main',
    component: Main,
  },
  {
    path: '/login',
    name: 'login',
    component: LoginForm,
  },
  {
    path: '/login/callback',
    name: 'oauthCallback',
    component: OAuthCallback,
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/',
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach((to, _from, next) => {
  const appStore = useAppStore()
  const userProfileStore = useUserProfileStore()
  const loginRequired = appStore.configuration?.login.isLoginRequired
  const isUserLoggedIn = userProfileStore.isLoggedIn
  const productEnabled = !!appStore.configuration?.components.productFromUrl.enabled
  const availableProducts = appStore.configuration?.components.productSelect.availableProducts ?? []

  const productFromUrl = appStore.productFromUrl ?? ''
  const shouldAppendProduct =
    to.name === 'main' &&
    !!appStore.configuration?.components.productFromUrl.enabled &&
    !!appStore.productFromUrl &&
    appStore.configuration.components.productSelect.availableProducts.includes(productFromUrl) &&
    to.query.product !== productFromUrl

  const productQuery = typeof to.query.product === 'string' ? to.query.product : ''
  const isValidQueryProduct =
    productEnabled && !!productQuery && availableProducts.includes(productQuery)

  if (isValidQueryProduct) {
    appStore.setProductFromUrl(productQuery)
  }

  console.log(`Router: ${loginRequired}, user: ${isUserLoggedIn}`)

  if (loginRequired === LoginRequired.Always && !isUserLoggedIn && to.name == 'main') {
    next({
      name: 'login',
    })
    return
  }

  if (loginRequired === LoginRequired.Never && to.name == 'login') {
    next({
      name: 'main',
      query: productFromUrl ? { product: productFromUrl } : undefined,
    })
    return
  }

  if (loginRequired === LoginRequired.Never && to.name == 'main') {
    next()
  }

  if (shouldAppendProduct) {
    next({
      name: 'main',
      query: {
        ...to.query,
        product: productFromUrl,
      },
    })
    return
  }
  next()
})

export default router
